import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add } from '@mui/icons-material';

/**
 * List Page Header Component - Dashboard style
 * Used for pages with larger title and subtitle (InvoicesList, SalesOrdersList, etc.)
 * 
 * @param {string} title - Page title
 * @param {string} subtitle - Page subtitle/description
 * @param {string} buttonText - Primary action button text
 * @param {function} onButtonClick - Primary button click handler
 * @param {React.ReactNode} buttonIcon - Custom button icon (default: Add)
 * @param {boolean} showButton - Whether to show the button
 * @param {React.ReactNode} additionalActions - Additional action buttons
 * @param {object} sx - Additional styles
 */
const ListPageHeader = ({
  title,
  subtitle,
  buttonText = 'New',
  onButtonClick,
  buttonIcon,
  showButton = true,
  additionalActions,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mb: 3,
        ...sx,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{
            color: '#333',
            fontSize: { xs: '1.5rem', md: '2rem' },
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        {additionalActions}
        {showButton && onButtonClick && (
          <Button
            variant="contained"
            startIcon={buttonIcon || <Add />}
            onClick={onButtonClick}
            sx={{
              backgroundColor: '#875A7B',
              textTransform: 'none',
              fontWeight: 500,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#714B68' },
            }}
          >
            {buttonText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ListPageHeader;
